import { Injectable } from "@angular/core";
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router
} from "@angular/router";
import { Observable } from "rxjs/Observable";
import {
  Store,
  AppState,
  AppFields,
  filter,
  map,
  take,
  AppTypes,
  combineLatest,
  ProgramsBillingType
} from "../store";

@Injectable()
export class TeamGuard implements CanActivate {
  constructor(private store: Store<AppState>, private router: Router) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    return combineLatest(
      this.store.select(AppFields.App, AppFields.TeamAccount),
      this.store.select(AppFields.App, AppFields.BillingTypeID),
      (isTeamAccount: boolean, billingTypeID: ProgramsBillingType) => {
        if (
          billingTypeID !== ProgramsBillingType.TeamBilling ||
          isTeamAccount
        ) {
          return true;
        } else {
          this.router.navigate(["/401"]);
        }
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/guards/team.guard.ts